import React from 'react';
import { FloatTarget } from './components/FloatTarget/FloatTarget';
import { FloatMobile } from './components/FloatMobile/FloatMobile';
import { FloatAnalytics } from './components/FloatAnalytics/FloatAnalytics';
import { FloatMascot } from './components/FloatMascot/FloatMascot';
import './HeroFloats.css';

export function HeroFloats() {
  return (
    <div className="hero-floats-layer">
      <FloatTarget />
      <FloatMobile />
      <FloatAnalytics />
      <FloatMascot />
    </div>
  );
}
